import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { setupIpecsManager } from "../api/admin";

export const useSetupIpecsManager = (onSuccess) => {
  const [formErrors, setFormErrors] = useState({});

  const { mutate: setupIpecsManagerMutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      await setupIpecsManager(data);
    },
    onSuccess: async () => {
      setFormErrors({});
      toast.success("iPECS credentials saved");
      await onSuccess?.();
    },
    onError: (error) => {
      if (error?.response?.status === 422) {
        const errors = error?.response?.data?.errors ?? {};
        const message = error?.response?.data?.message ?? null;
        setFormErrors(errors);
        if (Object.keys(errors).length === 0 && message) {
          toast.error(message);
        }
      } else {
        toast.error(
          "There was a problem connecting to iPECS. Please try again.",
        );
      }
    },
  });

  const resetForm = () => setFormErrors({});

  return { setupIpecsManagerMutate, formErrors, isLoading, resetForm };
};
